import React, { useMemo, useState } from "react";

import useLiveSponsors from "hooks/useLiveSponsors";
import useSponsors from "hooks/useSponsors";
import { marqueeEntries } from "utils/sponsors";
import SponsorsModal from "components/Sponsors/SponsorsModal";

function MarqueeRail({ items, variant }) {
  const loop = items.concat(items);
  return (
    <div className={"sm-rail sm-rail-" + variant}>
      <div className="sm-track">
        {loop.map((item, index) => (
          <span className="sm-item" key={`${variant}-${index}`}>
            <span className="sm-who">{item.sponsorName}</span>
            <span className="sm-what">{item.offering}</span>
          </span>
        ))}
      </div>
    </div>
  );
}

function SponsorMarquee() {
  const live = useLiveSponsors();
  const archive = useSponsors();
  const [modalOpen, setModalOpen] = useState(false);
  const [activeYear, setActiveYear] = useState(null);

  const liveYear = live.data != null ? live.data.year : null;
  const liveEntries = marqueeEntries(live.data);

  // The band leads with the season that is running. Before the first contribution of a new season
  // settles there is nothing to show, so it falls back to the most recent closed year rather than
  // leaving a hole where the sponsors used to be.
  const showingLive = liveEntries.length > 0;
  const bandData = showingLive ? live.data : archive.data;
  const bandYear = showingLive ? liveYear : archive.selectedYear;
  const entries = showingLive ? liveEntries : marqueeEntries(archive.data);

  const years = useMemo(() => {
    const all = [];
    if (liveYear != null) all.push(liveYear);
    archive.years.forEach((year) => {
      if (all.indexOf(year) === -1) all.push(year);
    });
    return all.sort((a, b) => b - a);
  }, [liveYear, archive.years]);

  if (entries.length === 0) {
    return null;
  }

  const shownYear = activeYear != null ? activeYear : bandYear;
  const onLiveYear = shownYear === liveYear;
  const modalData = onLiveYear ? live.data : archive.data;

  const selectYear = (year) => {
    setActiveYear(year);
    if (year !== liveYear) {
      archive.selectYear(year);
    }
  };

  const openModal = () => {
    setActiveYear(bandYear);
    setModalOpen(true);
  };

  const railA = entries.filter((item, index) => index % 2 === 0);
  const railB = entries.filter((item, index) => index % 2 === 1);

  return (
    <>
      <div className="sm-band">
        <div className="sm-head">
          <p className="sp-eyebrow">Our sponsors &middot; {bandYear}</p>
          <button className="sm-open" type="button" onClick={openModal}>
            See all sponsors
          </button>
        </div>
        <div className="sm-rails">
          <MarqueeRail items={railA} variant="a" />
          {railB.length > 0 && <MarqueeRail items={railB} variant="b" />}
        </div>
      </div>

      {modalOpen && (
        <SponsorsModal
          data={modalData != null ? modalData : bandData}
          year={shownYear}
          years={years}
          onSelectYear={selectYear}
          loading={onLiveYear ? live.loading : archive.loading}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}

export default SponsorMarquee;
